import PaginaNoEncontrada from "@/templates/Clarin/PaginaNoEncontrada404";
const NotFoundTemplate = (props) => {
  const { statusCode, menu, widgets, properties } = { ...props };
  return (
    <>
      {statusCode ? (
        <PaginaNoEncontrada menu={menu} widgets={widgets} properties={properties}/>
      ) : (
        "An error occurred on client"
      )}
    </>
  );
};
export default NotFoundTemplate;
